import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/3fd5cee58d131fe08dd51dfa0135fe96/305125c451f472e87b344b72de8267b9.jpeg" 
              alt="Novacréditos Logo" 
              className="h-10 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/') ? 'text-emerald-600' : isScrolled ? 'text-slate-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
              Inicio
            </Link>
            <Link to="/quienes-somos" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/quienes-somos') ? 'text-emerald-600' : isScrolled ? 'text-slate-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
              Quiénes Somos
            </Link>
            <Link to="/servicios" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/servicios') ? 'text-emerald-600' : isScrolled ? 'text-slate-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
              Servicios
            </Link>
            <Link to="/simulador" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/simulador') ? 'text-emerald-600' : isScrolled ? 'text-slate-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
              Simulador
            </Link>
            <Link to="/paises" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/paises') ? 'text-emerald-600' : isScrolled ? 'text-slate-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
              Países
            </Link>
            <Link to="/contacto" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/contacto') ? 'text-emerald-600' : isScrolled ? 'text-slate-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
              Contacto
            </Link>
          </div>

          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href="https://wa.me/447481624940?text=Hola%20Novacréditos,%20deseo%20información%20confidencial%20sobre%20sus%20servicios%20de%20crédito."
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-all whitespace-nowrap flex items-center gap-2 cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Contacto WhatsApp
            </a>
            <Link to="/iniciar-sesion" className={`px-5 py-2 text-sm font-medium rounded-lg transition-all whitespace-nowrap ${isScrolled ? 'text-slate-700 hover:bg-slate-100' : 'text-white hover:bg-white/10'}`}>
              Iniciar Sesión
            </Link>
            <Link to="/solicitar-credito" className="px-5 py-2 bg-slate-800 text-white text-sm font-medium rounded-lg hover:bg-slate-900 transition-all whitespace-nowrap">
              Solicitar Crédito
            </Link>
          </div>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-slate-800' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <div className="px-6 py-4 space-y-3">
            <Link to="/" className="block py-2 text-sm font-medium text-slate-700 hover:text-emerald-600">Inicio</Link>
            <Link to="/quienes-somos" className="block py-2 text-sm font-medium text-slate-700 hover:text-emerald-600">Quiénes Somos</Link>
            <Link to="/servicios" className="block py-2 text-sm font-medium text-slate-700 hover:text-emerald-600">Servicios</Link>
            <Link to="/simulador" className="block py-2 text-sm font-medium text-slate-700 hover:text-emerald-600">Simulador</Link>
            <Link to="/paises" className="block py-2 text-sm font-medium text-slate-700 hover:text-emerald-600">Países</Link>
            <Link to="/contacto" className="block py-2 text-sm font-medium text-slate-700 hover:text-emerald-600">Contacto</Link>
            <a 
              href="https://wa.me/447481624940?text=Hola%20Novacréditos,%20deseo%20información%20confidencial%20sobre%20sus%20servicios%20de%20crédito."
              target="_blank"
              rel="noopener noreferrer"
              className="block py-3 bg-emerald-600 text-white text-sm font-medium rounded-lg text-center hover:bg-emerald-700 cursor-pointer"
            >
              <i className="ri-whatsapp-line"></i> Contacto WhatsApp
            </a>
            <Link to="/iniciar-sesion" className="block py-2 text-sm font-medium text-slate-700 hover:text-emerald-600">Iniciar Sesión</Link>
            <Link to="/solicitar-credito" className="block py-3 bg-slate-800 text-white text-sm font-medium rounded-lg text-center hover:bg-slate-900">Solicitar Crédito</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
